import { Select } from '@mantine/core'

import { NotInterestedReason } from 'src/graphql/types/applicants'
import { formatSnakeValue } from 'src/lib/formatters'

import { inlineSelectProps } from './inlineSelectStyles'

const NotInterestedReasonOptions = ({
  selectedNotInterestedReason,
  setSelectedNotInterestedReason,
}) => {
  const notInterestedReasonOptions = Object.values(NotInterestedReason).map(
    (reason) => ({
      value: reason,
      label: formatSnakeValue(reason),
    })
  )

  return (
    <div className="flex flex-col gap-2 text-xs font-medium">      <Select
        {...inlineSelectProps}
        value={selectedNotInterestedReason?.notInterestedReason}
        onChange={(value) =>
          setSelectedNotInterestedReason({ notInterestedReason: value })
        }
        data={notInterestedReasonOptions}
        placeholder="Select not interested reason"
        className="max-w-sm"
        searchable
      />
    </div>
  )
}

export default NotInterestedReasonOptions
